import React from 'react';
import { List } from 'immutable';

import { Paragraph } from '@uncinc/react-drupal-core';
import {
  Container,
  Accordion,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

// Notice: This paragraph is deprecated. We now use the FAQ paragraph.
// But this paragraph has been updated to support the new styling.
const ParagraphFAQSelection = ({ entity }) => {
  return (
    <Container className="FAQ" small>
      <div className="row">
        <div className="col-12">
          {entity.get('field_questions') ? (
            <Accordion className="FAQ__accordion">
              {entity.get('field_questions', List()).map((paragraph) => {
                const id = paragraph.get('target_id');
                const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
                return (
                  <Paragraph
                    key={`paragraph:${id}:${language}`}
                    id={id}
                    entity={paragraph.get('entity')}
                  />
                );
              })}
            </Accordion>
          ) : null}
        </div>
      </div>
    </Container>
  );
};

export default ParagraphFAQSelection;
